import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ImpersonationService } from '@mysrc/app/modules/fwcore/services/impersonation.service';
import { OktaWrapperService } from '@mysrc/services/framework/okta-wrapper.service';
import { Observable, of } from 'rxjs';
import urlJoin from 'url-join';
import { BaseHttpReqRespService } from '.';
import { RequestLogCategory, RequestLogSystem, ResponseLogCategory, ResponseLogSystem } from '../../../features/admin/models';
import { IChangeLogEntry, IErrorLogEntry, IPageLogEntry, fwHttpClientUtils } from '../models';

@Injectable({
  providedIn: 'root'
})
export class LoggingService extends BaseHttpReqRespService {
  pageEndpoint: string = 'logs/pages';
  errorEndpoint: string = 'logs/errors';
  changeEndpoint: string = 'logs/changes';

  errorGridEndpoint: string = 'logs/errorsGrid';

  constructor(
    http: HttpClient,
    private router: Router,                              // owned here — private, used in log()
    @Inject('CONFIG_SETTINGS') config: any,      // no modifier — constructor body only
    oktaWrapper: OktaWrapperService,                     // no modifier — passing up
    impersonation: ImpersonationService                  // no modifier — passing up
  ) {
    super(http, config, impersonation, oktaWrapper);

  }

  async logPageView(url: string
    , user: string   // Do not wish the client to be able to define who saw what, should come from the claims resolved server side
    , token: string) {

    // Ignore login and '/'
    if (url == '/' || url.startsWith('/login')) {
      return;
    }

    const item = {
      url: url
    };

    const apiUrl = urlJoin(this.baseUrl, this.pageEndpoint);

    this.saveItem(item, true, apiUrl, this.getHttpBearerHeaders(token))
      .subscribe(err => console.log(err));
  }

  async log(item: any, user: string) {

    const token = this.getToken();

    const ditem = {
      loggedBy: user,
      url: this.router.url,
      message: item.message || item || 'Unknown client error',
      stack: item.stack || ''
    };

    
    const apiUrl = `${this.baseUrl}logs/system`;

    if (token != null) {

      this.saveItem(ditem, true, apiUrl, this.getHttpBearerHeaders(token))
        .subscribe();
    }
  }

  async logOld(item: any, user: string) {

    // Dont use a token. error logging should AllowAnonymous
    const ditem = {
      loggedBy: user,
      url: this.router.url,
      message: item.message || item || 'Unknown client error',
      stack: item.stack || ''
    };

    //const apiUrl = urlJoin(this.baseUrl, this.errorEndpoint);
    const apiUrl = `${this.baseUrl}logs/system`;

    this.saveItem(ditem, true, apiUrl, undefined)
      .subscribe(); //err => console.log(err)
  }

  getLogSystem$(req: RequestLogSystem): Observable<ResponseLogSystem> {
    const token = this.getToken();
    if (!!token) {
      const url = `${this.baseUrl}logs/system`;
      const httpOptions = {
        headers: this.getHttpBearerHeaders(token),
        params: fwHttpClientUtils.toHttpParams(req)
      };
      return this.http.get<ResponseLogSystem>(url, httpOptions);
    }
    return of(new ResponseLogSystem());
  }

  getLogSystemCategories$(req: RequestLogCategory): Observable<ResponseLogCategory> {
    const token = this.getToken();
    if (!!token) {
      const url = `${this.baseUrl}logs/system-categories`;
      const httpOptions = {
        headers: this.getHttpBearerHeaders(token),
        params: fwHttpClientUtils.toHttpParams(req)
      };
      return this.http.get<ResponseLogCategory>(url, httpOptions);
    }
    return of(new ResponseLogCategory());
  }

  // legacy - will be removed
  getErrorLogs(): Observable<IErrorLogEntry[]> {

    var token = this.getToken();
    if (token != null) {
      const url = urlJoin(this.baseUrl, this.errorEndpoint);
      return this.getItems<IErrorLogEntry>(url, this.getHttpBearerHeaders(token));
    }
    else {
      var emptyLogs: IErrorLogEntry[] = [];
      return of(emptyLogs);
    }

  }

  getPageLogs(): Observable<IPageLogEntry[]> {

    var token = this.getToken();
    if (token != null) {
      const url = urlJoin(this.baseUrl, this.pageEndpoint);
      return this.getItems<IPageLogEntry>(url, this.getHttpBearerHeaders(token));
    }
    else {
      var emptyLogs: IPageLogEntry[] = [];
      return of(emptyLogs);
    }

  }

  getChangeLogs(): Observable<IChangeLogEntry[]> {

    var token = this.getToken();
    if (token != null) {
      const url = urlJoin(this.baseUrl, this.changeEndpoint);
      return this.getItems<IChangeLogEntry>(url, this.getHttpBearerHeaders(token));
    }
    else {
      var emptyLogs: IChangeLogEntry[] = [];
      return of(emptyLogs);
    }

  }

}
